import { ComponentProps } from "react";

import { cva } from "class-variance-authority";

const textArea = cva(
  "text-ng-md flex h-min w-full min-w-64 shrink-0 items-center justify-center overflow-hidden overflow-y-auto rounded-md border-none bg-transparent px-3 py-2.5 text-neutral-700 shadow-[0px_0px_0px_0.5px_theme(colors.neutral.300),_0px_1px_3px_-1px_rgba(0,_0,_0,_0.05),_0px_1px_3px_0px_rgba(0,_0,_0,_0.10)] outline-none transition-shadow duration-100 placeholder:text-neutral-500 focus-within:shadow-[0px_0px_0px_1px_theme(colors.accent.800),_0px_0px_0px_4px_theme(colors.accent.200),_0px_1px_3px_-1px_rgba(0,_0,_0,_0.05),_0px_1px_3px_0px_rgba(0,_0,_0,_0.10)] hover:shadow-[0px_0px_0px_1px_theme(colors.neutral.300),_0px_1px_3px_-1px_rgba(0,_0,_0,_0.05),_0px_1px_3px_0px_rgba(0,_0,_0,_0.10)] focus-within:hover:shadow-[0px_0px_0px_1px_theme(colors.accent.800),_0px_0px_0px_4px_theme(colors.accent.200),_0px_1px_3px_-1px_rgba(0,_0,_0,_0.05),_0px_1px_3px_0px_rgba(0,_0,_0,_0.10)] focus:ring-0",
  {
    variants: {
      disabled: {
        true: "opacity-50",
        false: "",
      },
    },
    defaultVariants: {
      disabled: false,
    },
  },
);

type Props = ComponentProps<"textarea"> & {
  disabled?: boolean;
  rows?: number;
};

export function NgTextArea({ disabled, rows = 4, className, ...props }: Props) {
  return (
    <textarea
      className={textArea({ disabled, className })}
      rows={rows}
      disabled={disabled}
      {...props}
    />
  );
}
